import React, { useState, useEffect } from 'react';
import './App.css';
import './styles/animations.css';
import Hero from './components/Hero';
import StorySection from './components/StorySection';
import AdvantageSection from './components/AdvantageSection';
import CustomizedCraftsmanshipSection from './components/CustomizedCraftsmanshipSection';
import FifthSection from './components/FifthSection';
import SixthSection from './components/SixthSection';
import SeventhSection from './components/SeventhSection';
import Footer from './components/Footer';
import FloatingCircle from './components/FloatingCircle';

function App() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [sectionsLoaded, setSectionsLoaded] = useState({
    hero: false,
    story: false,
    advantage: false,
    craftsmanship: false,
    fifth: false,
    sixth: false,
    seventh: false,
    footer: false
  });

  useEffect(() => {
    // Initial page load animation
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    // All sections load immediately
    setSectionsLoaded({
      hero: true,
      story: true,
      advantage: true,
      craftsmanship: true,
      fifth: true,
      sixth: true,
      seventh: true,
      footer: true
    });

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <>
      <div className={`App ${isLoaded ? 'loaded' : 'loading'}`}>
        <div className={`page-load ${sectionsLoaded.hero ? 'loaded' : ''}`}>
          <Hero />
        </div>
        <div className={`page-load ${sectionsLoaded.story ? 'loaded' : ''}`}>
          <StorySection />
        </div>
        <div className={`page-load ${sectionsLoaded.advantage ? 'loaded' : ''}`}>
          <AdvantageSection />
        </div>
        <div className={`page-load ${sectionsLoaded.craftsmanship ? 'loaded' : ''}`}>
          <CustomizedCraftsmanshipSection />
        </div>
        <div className={`page-load ${sectionsLoaded.fifth ? 'loaded' : ''}`}>
          <FifthSection />
        </div>
        <div className={`page-load ${sectionsLoaded.sixth ? 'loaded' : ''}`}>
          <SixthSection />
        </div>
        <div className={`page-load ${sectionsLoaded.seventh ? 'loaded' : ''}`}>
          <SeventhSection />
        </div>
        <div className={`page-load ${sectionsLoaded.footer ? 'loaded' : ''}`}>
          <Footer />
        </div>
      </div>
      <FloatingCircle />
    </>
  );
}

export default App;
